import React from 'react';
import styles from './Spinner.module.css';

export default function Spinner({ size = 'md', label = 'Loading...', className = '' }) {
  return (
    <div className={`${styles.spinner} ${styles[size]} ${className}`} role="status">
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
